module.exports = __webpack_public_path__ + "img/green-1-diamond-striped.c1f0d76a.svg";